import getFieldError from "~/lib/getFieldError"

export const slideProps = {
  formOptions: Object,
  fieldValues: Object,
  content: Object,
  greeting: String,
  isStartingSlide: Boolean,
  isCurrentSlide: Boolean,
}

export const inputFieldsSlideMixin = {
  // requires the host component define 'fieldConfig'
  inject: ['updateField'],
  props: slideProps,
  data() {
    return {
      fieldErrors: {},
    }
  },
  computed: {
    mayContinue() {
      for (const [name, config] of Object.entries(this.fieldConfig)) {
        if (config.present && getFieldError(name, this.fieldValues[name], config)) {
          return false
        }
      }
      return true
    },
  },
  watch: {
    isCurrentSlide(value) {
      if (!value) {
        this.fieldErrors = {}
      }
    },
  },
  methods: {
    doUpdateField({ target, type }) {
      const value = target.type === 'checkbox' ? target.checked : target.value
      this.updateField?.(target.name, value, type === 'change' && 'sync')
      const error = getFieldError(target.name, value, this.fieldConfig[target.name])
      switch (type) {
      case 'input':
        if (!error) {
          delete this.fieldErrors[target.name]
        }
        break;
      case 'change':
        this.fieldErrors[target.name] = error
        break;
      }
    },
  },
}

export const multiOptionSelectSlideMixin = {
  // requires the host component define 'fieldName'
  inject: ['updateField'],
  props: slideProps,
  data() {
    return {
      error: null
    }
  },
  computed: {
    mayContinue() {
      const selectedOptions = this.fieldValues[this.fieldName]
      return selectedOptions && selectedOptions.length > 0
    },
  },
  watch: {
    isCurrentSlide(value) {
      if (value) {
        this.error = null
      }
    },
  },
  methods: {
    doUpdateField(value) {
      this.updateField?.(this.fieldName, value, 'sync')
      this.error = value.length === 0 ? 'requiredAny' : ''
    },
  },
  created() {
    if (!this.fieldValues[this.fieldName]) {
      this.updateField?.(this.fieldName, [])
    }
  },
}
